module.exports = __webpack_public_path__ + "img/type_single_select_icon.ae13e414.svg";